import React, { useState, useEffect, Suspense, startTransition } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import Logoe from "../../assets/img/Logoe.png";
// import { LuFilter } from "react-icons/lu";
// import { AiOutlineCloseCircle } from "react-icons/ai";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useTranslation } from "react-i18next";

// ✅ Lazy Load Components (Code Splitting)
const LanguageSelector = React.lazy(() => import("../Header/LanguageSelector"));
const Filter = React.lazy(() => import("../Filter/Filter"));
const Edit_2 = React.lazy(() => import("../Profile-Edit/Edit_2"));
const LocationSelector = React.lazy(() => import("./LocationSelector"));
const NoCopyWrapper = React.lazy(() => import("../../utils/NoCopyWrapper"));
const NoZoomWrapper = React.lazy(() => import("../../utils/NoZoomWrapper"));

function safeParse(json) {
  try {
    if (!json || json === "undefined") return null;
    return JSON.parse(json);
  } catch {
    return null;
  }
}



const Header = ({ onSearchChange }) => {
  const [showFilter, setShowFilter] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [avatar, setAvatar] = useState("");
  const [user, setUser] = useState(null);
  const [bgColor, setBgColor] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const isHomePage = location.pathname === "/"; 
  const [showFloating, setShowFloating] = useState(true);
  const [mode, setMode] = useState("login");
  let lastScrollY = window.scrollY;

  // 📱 Handle screen resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 👤 Check login
  useEffect(() => {
    const storedUser = safeParse(localStorage.getItem("user"));
    const token = localStorage.getItem("token");

    if (storedUser && token) {
      setUser(storedUser);
      setIsLogin(true);
      setAvatar(storedUser.avatar || "");
      if (!storedUser.avatar) {
        setBgColor("#FF6B6B"); // fallback color
      }
    } else {
      setIsLogin(false);
    }
  }, []);

  // 📜 Handle scroll (hide header on scroll down)
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY) {
        setShowFloating(false);
      } else {
        setShowFloating(true);
      }
      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // 👆 Handle drawer close outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      const drawer = document.querySelector(".mobile-drawer-slide");
      const button = document.querySelector(".hamburger");
      if (
        dropdownOpen &&
        drawer &&
        !drawer.contains(e.target) &&
        !button?.contains(e.target)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdownOpen]);

  const toggleFilter = () => setShowFilter((prev) => !prev);
  const toggleDropdown = () => setDropdownOpen((prev) => !prev);
  const handleSearchChange = (value) => {
    startTransition(() => {
      onSearchChange(value);
    });
  };

  return (
    <Suspense fallback={null}>
      <NoZoomWrapper>
        <NoCopyWrapper>
        <div className="container">
          {/* 👨‍💻 DESKTOP HEADER */}
          {!isMobile && (
            <div className="main-header-top">
              <div className="header">
                <div className="container-header-1">
                  <div className="logo">
                    <Link to="/">
                      <img
                        src={Logoe}
                        alt="Logo"
                        style={{ cursor: "pointer" }}
                      />
                    </Link>
                  </div>
                  <div className="search-and-filter">
                    <div className="surch-bar">
                      <i className="fa-solid fa-magnifying-glass"></i>
                      <input
                        type="text"
                        placeholder={t("search_here")}
                        onChange={(e) => handleSearchChange(e.target.value)}
                      />
                    </div>

                    {/* <button
                      id="filterBtn"
                      className={`filter ${showFilter}`}
                      onClick={toggleFilter}
                    >
                      <LuFilter />
                    </button> */}
                  </div>
                </div>
                <div className="containere-headere-2">
                  <LanguageSelector />

                  {!isLogin ? (
                    <div className="auth-buttons">
                      <button
                        className="login-btn"
                        onClick={() => navigate("/login")}
                      >
                        {t("login")}
                      </button>
                      <button
                        className="signup-btn"
                        onClick={() => navigate("/login?mode=signup")}
                      >
                        {t("signUp")}
                      </button>

                    </div>
                  ) : (
                    <>
                      <LocationSelector />
                      <div className="profile-avatar" onClick={toggleDropdown}>
                        <img
                          className="profile-avatar"
                          src={
                            avatar ||
                            `https://api.dicebear.com/7.x/initials/svg?seed=${user?.name?.charAt(0) || "U"
                            }`
                          }
                          alt="Profile"
                        />
                        {dropdownOpen && (
                          <div className="profile-dropdown">
                            <Edit_2 />
                          </div>
                        )}
                      </div>

                      <div
                        className="Add-page header-add-btn"
                        onClick={() => navigate("/Add-product")}
                      >
                        <IoIosAddCircleOutline className="add-icon" />
                        <h5>{t("add")}</h5>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* 📱 MOBILE HEADER */}
          {isMobile && (
            <>
              <div className="mobile-top-row">
                <div className="logoe">
                  <Link to="/">
                    <img src={Logoe} alt="Logo" />
                  </Link>
                </div>
                <LocationSelector />
              </div>

              <div className="mobile-middle-row">
                <div className="surch-bare">
                  <i className="fa-solid fa-magnifying-glass"></i>
                  <input
                    type="text"
                    placeholder={t("search_here")}
                    onChange={(e) => handleSearchChange(e.target.value)}
                  />
                </div>
                {/* <button
                  className={`filter ${showFilter ? "active" : ""}`}
                  onClick={toggleFilter}
                >
                  <LuFilter />
                </button> */}
              </div>

              {/* <div
                className={`mobile-drawer-slide ${dropdownOpen ? "open" : ""
                  }`}
              >
                <div className="drawer-header">
                  <AiOutlineCloseCircle
                    onClick={toggleDropdown}
                    className="close-icon"
                  />
                  <img src={Logoe} alt="Logo" className="drawer-logo" />
                </div>
              </div> */}
            </>
          )}
        </div>

          {showFilter && <Filter />}
        </NoCopyWrapper>
      </NoZoomWrapper>
    </Suspense>
  );
};

export default Header;
